// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"cac92294","149":"860a230a","628":"04d9ad4c"}[chunkId] + ".chunk.js";
};